import call from 'assets/about/call.png';
import customweather_logo_wide from 'assets/about/customweather_logo_wide.png';
import direct from 'assets/about/direct.png';
import email from 'assets/about/email.png';
import rescalert_small from 'assets/about/rescalert_small.png';
import seamless from 'assets/about/seamless.png';
import secure from 'assets/about/secure.png';
import unlimited from 'assets/about/unlimited.png';
import { IoCallOutline, IoInformationCircleOutline, IoSparklesOutline } from 'react-icons/io5';
import UserMenuPanel from './components/UserMenuPanel';

const FEATURES = [
  {
    icon: secure,
    title: 'Secure API',
    text: 'Our Open API allows for essentially unlimited integrations.',
  },
  {
    icon: unlimited,
    title: 'Unlimited Resources',
    text: 'Fusion+ is designed to integrate with any database and perform two-way synchronization.',
  },
  {
    icon: seamless,
    title: 'Seamless Integration',
    text: "Integrates with each organization's existing day-to-day system.",
  },
  {
    icon: direct,
    title: 'Direct Communication',
    text: 'Send alerts and messages to the people in your area and those just passing through.',
  },
];

export default function About() {
  return (
    <div className="user-menu-page">
      <UserMenuPanel icon={<IoInformationCircleOutline />} title="About RescAlert">
        <div className="user-menu-hero">
          {/* The logo repeats the heading, so it is decorative. */}
          <img src={rescalert_small} alt="" />
          <h3>What makes us different from others!</h3>
        </div>
        <p className="user-menu-lead">
          Our platform doesn't replace your existing system, it makes it better! Each organization
          continues to use their day-to-day platforms they know and trust. When it's time for the
          organization to respond to an emergency, RescAlert's Fusion+ connects them together in
          real-time
        </p>
        <div className="user-menu-feature-grid">
          {FEATURES.map((feature) => (
            <div key={feature.title} className="user-menu-feature">
              <img src={feature.icon} alt="" />
              <div>
                <h3>{feature.title}</h3>
                <p>{feature.text}</p>
              </div>
            </div>
          ))}
        </div>
      </UserMenuPanel>

      <UserMenuPanel icon={<IoSparklesOutline />} title="About Fusion+">
        <p className="user-menu-lead">
          Overwatch Fusion+ is an advanced platform that unifies devices and systems into a cohesive
          interface, leveraging AI to enhance emergency management. It integrates data from sensors,
          cameras, communication devices, and monitoring systems, providing real-time insights and
          predictive analytics. By consolidating this information, Overwatch Fusion+ improves
          decision-making and response efficiency, eliminating the need to switch between systems
          and ensuring streamlined emergency management.
        </p>
        <a
          className="user-menu-link align-self-start"
          href="https://www.rescalert.com/our-company/about-us.html"
          target="_blank"
          rel="noreferrer"
        >
          Learn more
        </a>
      </UserMenuPanel>

      <UserMenuPanel icon={<IoCallOutline />} title="Contact Us Now">
        <div className="user-menu-feature-grid">
          <div className="user-menu-feature">
            <img src={call} alt="" />
            <div>
              <h3>Call Us</h3>
              <a className="user-menu-link" href="tel:+18508609824">
                +1.850.860.9824
              </a>
            </div>
          </div>
          <div className="user-menu-feature">
            <img src={email} alt="" />
            <div>
              <h3>Email Us</h3>
              <a className="user-menu-link" href="mailto:sales.info@rescalert.com">
                sales.info@rescalert.com
              </a>
            </div>
          </div>
          <div className="user-menu-feature flex-column">
            <img
              className="user-menu-partner-logo"
              src={customweather_logo_wide}
              alt="CustomWeather"
            />
            <div>
              <p>Weather Data provided by Custom Weather.</p>
              <a
                className="user-menu-link"
                href="https://www.customweather.com/"
                target="_blank"
                rel="noreferrer"
              >
                https://www.customweather.com/
              </a>
            </div>
          </div>
        </div>
      </UserMenuPanel>
    </div>
  );
}
